module.exports = __webpack_public_path__ + "img/notLegislated.4f5481f2.svg";